exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Sxg_arPjf_RpQ23oDJCmk{font-size:16px;height:16px;line-height:31px;width:16px;color:\"[theme:neutralSecondary, default:#666666]\"!important}html[dir=ltr] .Sxg_arPjf_RpQ23oDJCmk{margin-left:16px;margin-right:12px}html[dir=rtl] .Sxg_arPjf_RpQ23oDJCmk{margin-right:16px;margin-left:12px}html[dir] ._140TfBsdtut-f-yKQDhuxF{padding-bottom:14px}", ""]);
// Exports
exports.locals = {
	"iconRoot": "Sxg_arPjf_RpQ23oDJCmk",
	"iconPadding": "_140TfBsdtut-f-yKQDhuxF"
};